import { render, staticRenderFns } from "./UiInput.vue?vue&type=template&id=2fd8f880&scoped=true"
import script from "./UiInput.vue?vue&type=script&lang=js"
export * from "./UiInput.vue?vue&type=script&lang=js"
import style0 from "./UiInput.vue?vue&type=style&index=0&id=2fd8f880&prod&scoped=true&lang=css"
import style1 from "./UiInput.vue?vue&type=style&index=1&id=2fd8f880&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8f880",
  null
  
)

export default component.exports